// src/domains/core/dashboard/components/widgets/health/OuraKeyMetricsWidget.tsx

import { Activity } from "lucide-react";
import { type FC } from "react";

import { Grid } from "@/components/ui";
import {
  ActivityScore,
  ReadinessScore,
  SleepScore,
  useOptimizedActivity,
  useOptimizedReadiness,
  useOptimizedSleep,
} from "@/domains/health/oura";

import { useWidgetConfig } from "../../../hooks/useWidgetConfig";
import { WIDGET_IDS } from "../../../store/widgetRegistry";
import { WidgetContainer } from "../base";

/**
 * OuraKeyMetricsWidget - Zeigt die wichtigsten Oura Metriken
 *
 * @returns {JSX.Element} Oura key metrics widget component
 *
 */
export const OuraKeyMetricsWidget: FC = () => {
  const { config } = useWidgetConfig(WIDGET_IDS.OURA_KEY_METRICS);

  // Oura Daten laden
  const { loading: loadingActivity, score: activityScore } = useOptimizedActivity();
  const { loading: loadingReadiness, score: readinessScore } = useOptimizedReadiness();
  const { loading: loadingSleep, score: sleepScore } = useOptimizedSleep();

  const loading = loadingActivity || loadingReadiness || loadingSleep;

  return (
    <WidgetContainer
      description="Activity, Readiness, Sleep"
      icon={<Activity className="w-5 h-5" />}
      loading={loading}
      size={config?.size ?? "medium"}
      title="Oura Key Metrics"
      widgetId={WIDGET_IDS.OURA_KEY_METRICS}
    >
      <Grid cols={{ lg: 3, md: 3, sm: 1 }} gap={3}>
        <ActivityScore score={activityScore} />
        <ReadinessScore score={readinessScore} />
        <SleepScore score={sleepScore} />
      </Grid>
    </WidgetContainer>
  );
};
